import { useAppSelector } from '../../../../../state/hooks';
import { getSelectedVehicleId } from '../../../state/onboardingUiSlice';
import { useCallback } from 'react';
import { routeStorage } from '../../../../../routes/routeStorage';
import { edenredUserManager } from '../../../../../login/external/edenredUserManager';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import Button from '@rio-cloud/rio-uikit/lib/es/Button';

export const EdenredLogin = () => {
  const selectedVehicleId = useAppSelector(getSelectedVehicleId);

  const onClick = useCallback(() => {
    routeStorage.saveVehicleId(selectedVehicleId ?? '');
    edenredUserManager.signinRedirect();
  }, [selectedVehicleId]);

  return (
    <>
      <div className="col-xs-12">
        <label>
          <CustomFormattedMessage id={'common.authentication'} />
        </label>
      </div>
      <div className="col-xs-12">
        <Button
          data-testid="onboarding-dialog-body-paymentCardProviderLoginButton"
          className={'margin-bottom-15'}
          onClick={onClick}
          bsStyle="primary"
        >
          <CustomFormattedMessage
            id={
              'onboarding.dialog.serviceCardForm.serviceCardType.edenredLogin.button'
            }
          />
        </Button>
      </div>
    </>
  );
};
